import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { ApiService } from "../../shared/services/api.service";
import { ToastrService } from "ngx-toastr";
import { elementAt, finalize } from "rxjs/operators";
import { UrlService } from "../../shared/services/url.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ViewportScroller } from "@angular/common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ReCaptchaV3Service } from "ng-recaptcha";

// import Typed from 'typed.js';

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  partnerDetailSentSuccess = false;
  pendingPartnerDetailForm: FormGroup;
  pendingPartner = false;
  tradingYears = ['0-1 years', '1-2 years', '2-5 years', 'More than 5 years'];
  showMinQualifications = false;
  @ViewChild('content', { read: TemplateRef }) content!: TemplateRef<any>;

  public howitworks: SwiperConfigInterface = {
    direction: "horizontal",
    slidesPerView: 1,
    keyboard: true,
    navigation: {
      nextEl: ".slider-control-next",
      prevEl: ".slider-control-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      bulletClass: "indicator",
      bulletActiveClass: "indicator_selected",
      clickable: true,
    },
    loop: true,
    autoHeight: true,
  };

  public guide: SwiperConfigInterface = {
    direction: "horizontal",
    slidesPerView: 1,
    keyboard: true,
    navigation: {
      nextEl: ".slider-control-next_guide",
      prevEl: ".slider-control-prev_guide",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      bulletClass: "indicator",
      bulletActiveClass: "indicator_selected",
      clickable: true,
    },
    loop: true,
    autoHeight: true,
  };

  howItWorksCurrentSlide = 0;

  guideCurrentSlide = 0;

  shareDetailsForm: FormGroup;
  sharePartnerDetailsForm: FormGroup;

  pendingShareDetails = false;
  heroHeaderText;
  headers = ["Supporting your business every step of the way"];
  heroSecondaryText;
  herotexts = [
    "Lending that provides you with continuously updated, individual repayment terms and funding limits",
  ];

  colorClassesNames = [
    "color",
    "color-white",
    "color",
    "color",
    "color-blue",
    "color-orange",
    "color-white-gray",
  ];
  registerForm: FormGroup;

  showLaunchPanel = this.urlService.checkUrlCo();

  applicationPortalSite;

  pendingRegisterForm = false;

  @HostListener("window:scroll", ["$event"])
  onWindowScroll(e) {
    if (!this.urlService.checkUrlCo()) {
      const panels = document.getElementsByClassName("panel");
      const scroll = window.scrollY + window.innerHeight / 1.5;

      for (let i = 0; i < panels.length; i++) {
        const panel = panels[i] as HTMLElement;

        if (
          panel.offsetTop <= scroll &&
          panel.offsetTop + panel.offsetHeight > scroll
        ) {
          for (let j = 0; j < panels.length; j++) {
            this.colorClassesNames.map((className) =>
              panels[j].classList.remove(className)
            );
            panels[j].classList.add(this.colorClassesNames[i]);
          }
        }
      }
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private toastr: ToastrService,
    public urlService: UrlService,
    private router: Router,
    private modalService: NgbModal,
    private scroller: ViewportScroller,
    private route: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {

    this.applicationPortalSite = window["appConfig"]["applicationPortalSite"];

  }

  ngOnInit(): void {
    this.initRegisterForm();
    this.initPendingPartnerDetailForm();

    if (this.urlService.checkUrlCom()) {
      this.initShareDetailsForm();
      this.heroHeaderText = this.headers[0];
      this.heroSecondaryText = this.herotexts[0];
      const heroHeaderWrapperElement = document.getElementById(
        "hero-header-wrapper"
      );
      if (heroHeaderWrapperElement) {
        heroHeaderWrapperElement.style.maxWidth = 700 + "px";
      }
    } else {
      this.initSharePartnerDetailsForm();
    }

    this.route.queryParams.subscribe((params) => {

      if (params.offer && params.offer === 'external') {
        this.showMinQualifications = true;
      }
      else {
        this.showMinQualifications = false;
      }
    });
  }

  private initShareDetailsForm() {
    this.shareDetailsForm = this.formBuilder.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      companyName: ["", [Validators.required]],
      phoneNumber: ["", [Validators.required]],
    });
  }

  private initSharePartnerDetailsForm() {
    this.sharePartnerDetailsForm = this.formBuilder.group({
      firstName: ["", [Validators.required]],
      phoneNumber: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required]],
      yearsTrading: ["", [Validators.required]],
      zipcode: ["", [Validators.required]],
    });
  }
  private initPendingPartnerDetailForm() {
    this.pendingPartnerDetailForm = this.formBuilder.group({
      firstname: ["", [Validators.required]],
      lastname: ["", [Validators.required]],
      phone: ["", [Validators.required]],
      company: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      customertype: ["", [Validators.required]]
    });
  }

  recaptcha: any;
  submitPendingPartnerDetail() {
    this.pendingPartner = true;
    if (this.pendingPartnerDetailForm.valid) {
      this.recaptcha = this.recaptchaV3Service.execute('home')
        .subscribe(
          (token) => {
            this.apiService
              .sendMessage("LearnMoreAsPartner", this.pendingPartnerDetailForm.value)
              .pipe(finalize(() => (this.pendingPartner = false)))
              .subscribe(
                (data) => {
                  this.pendingPartnerDetailForm.reset();
                  this.toastr.success("Your details has been sent");
                },
                (error) => {
                  this.toastr.error("Server Error. Try again later");
                }
              );
          },
          (error) => {
            this.toastr.error("Recaptcha Error");
          }
        );
    } else {
      if (this.pendingPartnerDetailForm.controls["firstname"].invalid) {
        this.toastr.error("First name is required");
      }
      if (this.pendingPartnerDetailForm.controls["lastname"].invalid) {
        this.toastr.error("Last name is required");
      }
      if (this.pendingPartnerDetailForm.controls["phone"].invalid) {
        this.toastr.error("Phone is invalid");
      }
      if (this.pendingPartnerDetailForm.controls["company"].invalid) {
        this.toastr.error("Company is required");
      }
      if (this.pendingPartnerDetailForm.controls["email"].invalid) {
        this.toastr.error("Email address is invalid");
      }
      if (this.pendingPartnerDetailForm.controls["customertype"].invalid) {
        this.toastr.error("Customer type is invalid");
      }
      this.pendingPartner = false;
    }
  }

  initRegisterForm() {
    this.registerForm = this.formBuilder.group({
      firstName: ["", [Validators.required]],
      phone: ["", [Validators.required]],
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required]],
    });
  }

  shareDetails() {
    this.pendingShareDetails = true;
    if (this.shareDetailsForm.valid) {
      this.apiService
        .sendMessage("LearnMore", this.shareDetailsForm.value)
        .pipe(finalize(() => (this.pendingShareDetails = false)))
        .subscribe(
          (data) => {
            this.toastr.success("Your details has been sent");
          },
          (error) => {
            this.toastr.error("Server Error. Try again later");
          }
        );
    } else {
      this.toastr.error("Form is invalid. Enter correct information");
      this.pendingShareDetails = false;
    }
  }

  sharePartnerDetails() {
    this.pendingShareDetails = true;
    if (this.sharePartnerDetailsForm.valid) {
      this.apiService
        .sendMessage("Enqury", this.sharePartnerDetailsForm.value)
        .pipe(finalize(() => (this.pendingShareDetails = false)))
        .subscribe(
          (data) => {
            this.toastr.success("Your details has been sent");
            this.partnerDetailSentSuccess = true;
            setTimeout(function () {
              this.partnerDetailSentSuccess = false;
            }, 500);
            this.sharePartnerDetailsForm.reset();
          },
          (error) => {
            this.toastr.error("Server Error. Try again later");
            this.sharePartnerDetailsForm.reset();
          }
        );
    } else {
      this.toastr.error("Form is invalid. Enter correct information");
      this.pendingShareDetails = false;
    }
  }

  register() {
    this.pendingRegisterForm = true;
    window.document.location.href = "https://portal.plexe.co/public?partnerId=080f0dda-6d19-4e6d-8527-0607389374d9";
  }

  scrollToElement($element): void {
    $element.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });
  }

  openDialog($event) {
    this.modalService.open(this.content, { centered: true });
    $event.preventDefault();
  }

  ToFaq() {
    this.router.navigate(["/faq"]);
  }

  ToHome() {
    this.router.navigate(["/our-story"]);
  }

  ToHowItWorks() {
    this.router.navigate(["/how-it-works"]);
  }

  ngAfterViewInit() {
    const tree = this.router.parseUrl(this.router.url);
    if (tree.fragment) {
      this.scroller.scrollToAnchor(tree.fragment);
    }
  }

  Continue() {
    this.pendingRegisterForm = true;

    let partnerid = '';
    if (localStorage.getItem('partnerid')) {
      partnerid = localStorage.getItem('partnerid');
    }
    else {
      partnerid = '080f0dda-6d19-4e6d-8527-0607389374d9';
    }

    window.document.location.href = "https://portal.plexe.co/public?partnerId=" + partnerid;
  }

  ngOnDestroy() {
    if (this.recaptcha) {
      this.recaptcha.unsubscribe();
    }
  }
}
